import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpStatus } from '../../common/enums/HttpStatus';
import { IMedia } from '../../common/interfaces/Media.interface';
import { createBaseQuery } from './utils/createBaseQuery';

export const mediaApi = createApi({
  reducerPath: 'MediaApi',
  baseQuery: createBaseQuery('/media'),
  tagTypes: ['Media'],
  endpoints: (builder) => ({
    fetchMedia: builder.query<
      { code: HttpStatus; data: IMedia[] },
      { page: number; size: number }
    >({
      query: ({ page, size }) => `?page=${page}&size=${size}`,
      providesTags: (result) =>
        result
          ? [
              { type: 'Media' as const, id: 'LIST' },
              ...result.data.map(({ id }) => ({
                type: 'Media' as const,
                id,
              })),
            ]
          : [{ type: 'Media' as const, id: 'LIST' }],
    }),
    createMedia: builder.mutation<IMedia, Partial<IMedia>>({
      query: (newContent) => ({
        url: '',
        method: 'POST',
        body: newContent,
      }),
      transformResponse: (response: { code: HttpStatus; data: IMedia }) =>
        response.data,
      invalidatesTags: [{ type: 'Media', id: 'LIST' }],
    }),
  }),
});

export const { useFetchMediaQuery, useCreateMediaMutation } = mediaApi;
